import {
  View,
  Text,
  TouchableOpacity,
  Modal,
  Image,
  ScrollView,
  StyleSheet,
} from "react-native";
import { LinearGradient } from "expo-linear-gradient";
import React, { useRef, useState } from "react";
import Ionicons from "@expo/vector-icons/Ionicons";
import {
  useDeviceSize,
  CreateResponsiveStyle,
  DEVICE_SIZES,
} from "rn-responsive-styles";
import { AppColors } from "../../../utility/AppColors";
import { s } from "react-native-size-matters";
import { AppFontStyle } from "../../../styles/AppFontStyle";
import { AppImages } from "../../../utility/AppImages";
import { StackActions, useNavigation } from "@react-navigation/native";
import { navigateToScreen } from "../../../utility/NavigationHelper";
import { AppScreens } from "../../Utility/AppScreens";
import { toast } from "react-toastify";
import Separator from "../../../Components/Separator";
import EventInfo from "./EventInfo";
import SvgImage from "../../../Components/choose-avatar-components/SvgImage";

const EventTypeScreen = (props, route) => {
  const routeData = route.params;
  const navigation = useNavigation();
  const { showModal = false, setShowModal } = props;
  const [privateType, setPrivateType] = useState(false);
  const [publicType, setPublicType] = useState(false);
  const [createEvent, setCreateEvent] = useState(false);
  const [eventType, setEventType] = useState(2); // public = 2, private = 1
  const [showInfo, setShowInfo] = useState(false);
  const onCloseClick = () => {
    setShowModal(false);
  };

  const playTypePickerRef = useRef();

  const styles = useStyles();
  const deviceSize = useDeviceSize();
  const isMobile = deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM;

  return (
    <Modal
      animationType={isMobile ? "slide" : "fade"}
      transparent={true}
      visible={showModal}
      onRequestClose={onCloseClick}
    >
      <View
        style={[
          styles.container,
          isMobile ? { justifyContent: "flex-end" } : { justifyContent: "center", alignItems: "center" },
        ]}
      >
        <LinearGradient
          colors={["#111827", "#000000"]}
          start={{ x: 0, y: 0 }}
          end={{ x: 1, y: 1 }}
          style={[styles.mainView, {}]}
        >
          {/* Handle bar for mobile */}
          {isMobile && (
            <View style={{
              width: 40,
              height: 4,
              backgroundColor: "#6B7280",
              borderRadius: 2,
              alignSelf: "center",
              marginBottom: 8,
            }} />
          )}
          <View style={{ flexDirection: "row", paddingTop: isMobile ? 10 : 20 }}>
            <Text
              style={[
                deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
                  ? AppFontStyle.BOLD_ANYBODY_24
                  : AppFontStyle.BOLD_ANYBODY_32,
                {
                  flex: 1,
                },
              ]}
            >
              Event type
            </Text>

            <TouchableOpacity
              style={{
                justifyContent: "center",
                alignItems: "center",
              }}
              onPress={() => {
                onCloseClick();
              }}
            >
              <Image
                source={AppImages.icCloseWhite}
                style={{
                  height:
                    deviceSize === DEVICE_SIZES.SM ||
                      deviceSize === DEVICE_SIZES.XS
                      ? 20
                      : 35,
                  width:
                    deviceSize === DEVICE_SIZES.SM ||
                      deviceSize === DEVICE_SIZES.XS
                      ? 20
                      : 35,
                }}
              />
            </TouchableOpacity>
          </View>
          <Separator
            color={AppColors.grayColor_565656}
            height={2}
            marginTop={16}
            marginBottom={0}
            marginHorizontal={0}
          />

          <Text style={[AppFontStyle.REGULAR_ANYBODY_14, styles.headerTitle]}>
            Select the type of your event
          </Text>
          <View style={{ position: "relative", alignSelf: "flex-end" }}>
            <TouchableOpacity
              style={{ padding: 8 }}
              onPress={() => setShowInfo(!showInfo)}
            >
              <Image
                source={AppImages.icInfoCircle}
                style={{ height: 20, width: 20 }}
              />
            </TouchableOpacity>

            {/* Conditionally render the popup right next to the icon */}
          </View>
          <ScrollView
            contentContainerStyle={{
              flexGrow: 1,
              alignItems: "center",
            }}
            style={{
              marginVertical:
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? 15
                  : 0,
            }}
            showsVerticalScrollIndicator={false}
          >
            {showInfo && (
              <View
                style={[
                  styles.infoPopupContainer,
                  {
                    right:
                      deviceSize === DEVICE_SIZES.XS ||
                        deviceSize === DEVICE_SIZES.SM
                        ? 0
                        : 30,
                  },
                ]}
              >
                <EventInfo onCloseClick={() => setShowInfo(false)} />
              </View>
            )}
            <View style={styles.buttonWrapper}>
              {/* KALL OUT Button */}
              <View
                style={{
                  alignItems: "center",
                  flexDirection: "column",
                  flex: isMobile ? 1 : undefined,
                }}
              >
                <TouchableOpacity
                  style={[
                    styles.eventBgView,
                    {
                      borderColor:
                        eventType === 2
                          ? "#DC2626"
                          : AppColors.appBlackColor_1e1e1e,
                    },
                  ]}
                  onPress={() => {
                    setEventType(2);
                  }}
                >
                  <View
                    style={
                      eventType == 2 ? styles.selectedDot : styles.unselectedDot
                    }
                  />

                  <SvgImage src={AppImages.icPublic} variant="eventCreate" />
                </TouchableOpacity>
                <View
                  style={{
                    flexDirection: "row",
                    marginTop: isMobile ? 10 : 20,
                    gap: 6,
                    justifyContent: "center",
                  }}
                >
                  <Image
                    source={AppImages.icPublicLogo}
                    style={{
                      height:
                        deviceSize === DEVICE_SIZES.SM ||
                          deviceSize === DEVICE_SIZES.XS
                          ? 15
                          : 23,
                      width:
                        deviceSize === DEVICE_SIZES.SM ||
                          deviceSize === DEVICE_SIZES.XS
                          ? 18
                          : 23,
                    }}
                  />
                  <Text
                    style={[
                      deviceSize === DEVICE_SIZES.SM ||
                        deviceSize === DEVICE_SIZES.XS
                        ? AppFontStyle.REGULAR_ANYBODY_14
                        : AppFontStyle.REGULAR_ANYBODY_24,
                      {
                        color: AppColors.white,
                        textAlign: "center",
                      },
                    ]}
                  >
                    KALL OUT
                  </Text>
                </View>
              </View>

              {/* EXCLUSIVE Button */}
              <View
                style={{
                  alignItems: "center",
                  flexDirection: "column",
                  flex: isMobile ? 1 : undefined,
                }}
              >
                <TouchableOpacity
                  style={[
                    styles.eventBgView,
                    {
                      borderColor:
                        eventType === 1
                          ? "#DC2626"
                          : AppColors.appBlackColor_1e1e1e,
                    },
                  ]}
                  disabled={true}
                  onPress={() => {
                    // setEventType(1);
                  }}
                >
                  <View
                    style={
                      eventType == 1 ? styles.selectedDot : styles.unselectedDot
                    }
                  />
                  <SvgImage src={AppImages.icPrivate} variant="eventCreate" />
                  <View
                    style={{
                      ...StyleSheet.absoluteFillObject,
                      backgroundColor: "rgba(0, 0, 0, 0.5)",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: 5,
                    }}
                  >
                    <Image
                      source={AppImages.icLock}
                      style={{
                        width: 30,
                        height: 30,
                      }}
                    />
                  </View>
                </TouchableOpacity>
                <View
                  style={{
                    flexDirection: "row",
                    marginTop: 20,
                    gap: 6,
                    width:
                      deviceSize === DEVICE_SIZES.SM ||
                        deviceSize === DEVICE_SIZES.XS
                        ? "30%"
                        : null,
                  }}
                >
                  <Image
                    source={AppImages.icPrivateLogo}
                    style={{
                      height:
                        deviceSize === DEVICE_SIZES.SM ||
                          deviceSize === DEVICE_SIZES.XS
                          ? 15
                          : 23,
                      width:
                        deviceSize === DEVICE_SIZES.SM ||
                          deviceSize === DEVICE_SIZES.XS
                          ? 18
                          : 23,
                    }}
                  />{" "}
                  <Text
                    style={[
                      deviceSize === DEVICE_SIZES.SM ||
                        deviceSize === DEVICE_SIZES.XS
                        ? AppFontStyle.REGULAR_ANYBODY_14
                        : AppFontStyle.REGULAR_ANYBODY_24,
                      {
                        color: AppColors.white,
                        textAlign: "center",
                      },
                    ]}
                  >
                    EXCLUSIVE
                  </Text>
                </View>
              </View>
            </View>
          </ScrollView>

          {/* Buttons */}
          <View
            style={{
              flexDirection: "row",
              gap: 12,
              paddingBottom: 20,
              paddingTop: 10,
              justifyContent: isMobile ? "center" : "space-between",
            }}
          >
            {/* Back Button */}
            <TouchableOpacity
              style={{
                flex: isMobile ? 0.4 : undefined,
                width: isMobile ? undefined : 100,
                backgroundColor: "transparent",
                borderWidth: 1,
                borderColor: "#FFF",
                borderRadius: 8,
                paddingVertical: 12,
                paddingHorizontal: isMobile ? 20 : 30,
                justifyContent: "center",
                alignItems: "center",
              }}
              onPress={onCloseClick}
            >
              <Text
                style={[
                  AppFontStyle.BOLD_ANYBODY_14,
                  { color: AppColors.white },
                ]}
              >
                Back
              </Text>
            </TouchableOpacity>

            {/* Next Button */}
            <TouchableOpacity
              style={{
                flex: isMobile ? 1 : undefined,
                width: isMobile ? undefined : 100,
                backgroundColor: "#DC2626",
                borderRadius: 8,
                justifyContent: "center",
                alignItems: "center",
                paddingVertical: 12,
              }}
              onPress={() => {
                if (eventType === 1) {
                  setShowModal(false);
                  navigateToScreen(
                    navigation,
                    AppScreens.CreatePrivateEventScreen,
                    { eventType: "Private" }
                  );
                } else if (eventType === 2) {
                  setShowModal(false);
                  navigateToScreen(
                    navigation,
                    AppScreens.CreatePublicEventScreen,
                    { eventType: "Public" }
                  );
                } else {
                  toast.error("Please select event type");
                }
              }}
            >
              <Text
                style={[
                  AppFontStyle.BOLD_ANYBODY_14,
                  { color: AppColors.white },
                ]}
              >
                Next
              </Text>
            </TouchableOpacity>
          </View>
        </LinearGradient>
      </View>
    </Modal>
  );

  // function privateTypeSelection() {
  //     setPrivateType(true);
  //     setPublicType(false);
  // }

  // function publicTypeSelection() {
  //     setPrivateType(false);
  //     setPublicType(true);
  // }
};

export default EventTypeScreen;

const useStyles = CreateResponsiveStyle(
  {
    infoPopupContainer: {
      position: "absolute",
      top: -10,
      zIndex: 9999,
    },
    container: {
      flex: 1,
      backgroundColor: AppColors.blackTrans_000000a8,
    },
    mainView: {
      paddingHorizontal: 40,
      paddingVertical: 20,
      margin: 30,
      alignSelf: "center",
      borderRadius: 8,
      borderWidth: 1.6,
      borderColor: "rgba(239, 68, 68, 0.50)",
    },
    headerTitle: {
      color: AppColors.gray_C3C3C3,
      paddingTop: 10,
    },
    eventBgView: {
      flexGrow: 1,
      padding: 24,
      flex: 1,
      flexDirection: "row",
      backgroundColor: AppColors.appBlackColor_1e1e1e,
      alignItems: "center",
      justifyContent: "flex-start",
      gap: 10,
      borderColor: AppColors.appBlackColor_1e1e1e,
      borderWidth: 1,
      borderRadius: 10,
    },
    selectedDot: {
      height: 17,
      width: 17,
      borderRadius: 18,
      backgroundColor: AppColors.appViolentColor_6D08C3,
      position: "absolute",
      top: 5,
      left: 7,
    },
    unselectedDot: {
      height: 17,
      width: 17,
      borderRadius: 18,
      borderColor: "#454545",
      position: "absolute",
      top: 5,
      left: 7,
      borderWidth: 1,
    },
    buttonWrapper: {
      marginBottom: 35,
      flexDirection: "row",
      justifyContent: "space-around",
      gap: 20,
    },
  },
  {
    [DEVICE_SIZES.MD]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
      },
      mainView: {
        // width: "60%",
        backgroundColor: AppColors.purple_453B50,
        paddingHorizontal: 20,
        margin: 30,
        alignSelf: "center",
        borderRadius: 12,
      },
      eventBgView: {
        flexGrow: 1,
        padding: 24,
        flex: 1,
        flexDirection: "row",
        backgroundColor: AppColors.appBlackColor_1e1e1e,
        alignItems: "center",
        justifyContent: "flex-start",
        gap: 10,
      },
      selectedDot: {
        height: 17,
        width: 17,
        borderRadius: 18,
        backgroundColor: AppColors.appViolentColor_6D08C3,
        position: "absolute",
        top: 5,
        left: 7,
      },
      unselectedDot: {
        height: 17,
        width: 17,
        borderRadius: 18,
        borderColor: "#454545",
        position: "absolute",
        top: 5,
        left: 7,
        borderWidth: 1,
      },
      buttonWrapper: {
        marginBottom: 35,
        flexDirection: "row",
        justifyContent: "space-around",
        gap: 20,
      },
    },
    [DEVICE_SIZES.LG]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
      },
      mainView: {
        // width: "60%",
        backgroundColor: AppColors.purple_453B50,
        paddingHorizontal: 20,
        margin: 30,
        alignSelf: "center",
        borderRadius: 12,
      },
      eventBgView: {
        flexGrow: 1,
        padding: 24,
        flex: 1,
        flexDirection: "row",
        backgroundColor: AppColors.appBlackColor_1e1e1e,
        alignItems: "center",
        justifyContent: "flex-start",
        gap: 10,
      },
      selectedDot: {
        height: 17,
        width: 17,
        borderRadius: 18,
        backgroundColor: AppColors.appViolentColor_6D08C3,
        position: "absolute",
        top: 5,
        left: 7,
      },
      unselectedDot: {
        height: 17,
        width: 17,
        borderRadius: 18,
        borderColor: "#454545",
        position: "absolute",
        top: 5,
        left: 7,
        borderWidth: 1,
      },
      buttonWrapper: {
        marginBottom: 35,
        flexDirection: "row",
        justifyContent: "space-around",
        gap: 20,
      },
    },
    [DEVICE_SIZES.SM]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
        justifyContent: "flex-end",
      },
      mainView: {
        width: "100%",
        paddingHorizontal: 16,
        paddingVertical: 15,
        marginHorizontal: 0,
        marginVertical: 0,
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        borderWidth: 1,
        borderBottomWidth: 0,
        borderColor: "#DC2626",
        shadowColor: "rgba(232, 232, 232, 0.15)",
        shadowOffset: { width: 0, height: -3 },
        shadowOpacity: 1,
        shadowRadius: 14,
      },
      eventBgView: {
        width: 160,
        height: 145,
        padding: 8,
        flexDirection: "column",
        backgroundColor: AppColors.appBlackColor_1e1e1e,
        alignItems: "center",
        justifyContent: "center",
        gap: 8,
        borderRadius: 10,
        borderWidth: 2,
      },
      selectedDot: {
        height: 17,
        width: 17,
        borderRadius: 18,
        backgroundColor: AppColors.appViolentColor_6D08C3,
        position: "absolute",
        top: 5,
        left: 7,
      },
      unselectedDot: {
        height: 17,
        width: 17,
        borderRadius: 18,
        borderColor: "#454545",
        position: "absolute",
        top: 5,
        left: 7,
        borderWidth: 1,
      },
      buttonWrapper: {
        marginBottom: 20,
        flexDirection: "row",
        justifyContent: "center",
        gap: 12,
      },
    },
    [DEVICE_SIZES.XS]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
        justifyContent: "flex-end",
      },
      mainView: {
        width: "100%",
        paddingHorizontal: 12,
        paddingVertical: 15,
        marginHorizontal: 0,
        marginVertical: 0,
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        borderWidth: 1,
        borderBottomWidth: 0,
        borderColor: "#DC2626",
        shadowColor: "rgba(232, 232, 232, 0.15)",
        shadowOffset: { width: 0, height: -3 },
        shadowOpacity: 1,
        shadowRadius: 14,
      },
      eventBgView: {
        width: 160,
        height: 145,
        padding: 8,
        flexDirection: "column",
        backgroundColor: AppColors.appBlackColor_1e1e1e,
        alignItems: "center",
        justifyContent: "center",
        gap: 8,
        borderRadius: 10,
        borderWidth: 2,
      },
      selectedDot: {
        height: 17,
        width: 17,
        borderRadius: 18,
        backgroundColor: AppColors.appViolentColor_6D08C3,
        position: "absolute",
        top: 5,
        left: 7,
      },
      unselectedDot: {
        height: 17,
        width: 17,
        borderRadius: 18,
        borderColor: "#454545",
        position: "absolute",
        top: 5,
        left: 7,
        borderWidth: 1,
      },
      buttonWrapper: {
        marginBottom: 20,
        flexDirection: "row",
        justifyContent: "center",
        gap: 12,
      },
    },
  }
);
